<script>
import {defineComponent} from 'vue'
import {Link} from "@inertiajs/vue3";
import IconLogo from "@js/components/Icons/IconLogo.vue";
import ModalSelect from "@js/components/Input/ModalSelect.vue";
import IconChevronDown from "@js/components/Icons/IconChevronDown.vue";
import IconDesigner from "@js/components/Icons/IconDesigner.vue";
import IconBuilder from "@js/components/Icons/IconBuilder.vue";
import IconArchitecture from "@js/components/Icons/IconArchitecture.vue";

export default defineComponent({
    name: "B2BTopBar",
    components: {
        IconArchitecture,
        IconBuilder,
        IconDesigner,
        IconChevronDown,
        ModalSelect,
        IconLogo,
        Link,
    }
})
</script>

<template>
    <div class="bg-black text-white pt-[16px]">
        <div class="container flex items-center justify-between">
            <Link :href="route('home')" aria-label="Лого">
                <IconLogo class="h-[44px] max-w-[200px] object-contain"
                          text_color="#fff"
                          icon_first_color="#ffcf33"
                          icon_second_color="#ffcf33"
                          bottom_text_color="#ffcf33"/>
            </Link>
            <ModalSelect :buttonClass="'bg-transparent font-normal'" widthClass="w-64">
                <template #button>
                    <div
                        class="flex items-center gap-1 group-hover:text-navHoverColor transition border-2 border-baseYellow rounded-lg px-5 py-2.5">
                        <div>
                            B2B Услуги
                        </div>
                        <IconChevronDown
                            class="w-4 h-4 text-gray-600 group-hover:text-navHoverColor transition"/>
                    </div>
                </template>
                <template #menu>
                    <ul class=" text-sm text-gray-700">
                        <Link :href="route('B2BForBuilders')">
                            <li class="block px-4 py-4 font-medium cursor-pointer md:hover:bg-gray-100">
                                <div
                                    class="flex items-center gap-2 text-sm font-bold leading-tight mt-0.5">
                                    Девелоперам и застройщикам
                                </div>
                            </li>
                        </Link>
                        <Link :href="route('B2BForJBI')">
                            <li class="block px-4 py-4 font-medium cursor-pointer md:hover:bg-gray-100">
                                <div
                                    class="flex items-center gap-2 text-sm font-bold leading-tight mt-0.5">
                                    Производителям ЖБИ и Бетонным заводам
                                </div>
                            </li>
                        </Link>
                        <Link :href="route('B2BForLSTC')">
                            <li class="block px-4 py-4 font-medium cursor-pointer md:hover:bg-gray-100">
                                <div
                                    class="flex items-center gap-2 text-sm font-bold leading-tight mt-0.5">
                                    Производителям ЛСТК
                                </div>
                            </li>
                        </Link>
                        <Link :href="route('B2BForInstallationOrganizations')">
                            <li class="block px-4 py-4 font-medium cursor-pointer md:hover:bg-gray-100">
                                <div
                                    class="flex items-center gap-2 text-sm font-bold leading-tight mt-0.5">
                                    Монтажным организациям
                                </div>
                            </li>
                        </Link>
                        <Link :href="route('B2BForAgro')">
                            <li class="block px-4 py-4 font-medium cursor-pointer md:hover:bg-gray-100">
                                <div
                                    class="flex items-center gap-2 text-sm font-bold leading-tight mt-0.5">
                                    Сельхоз предприятиям
                                </div>
                            </li>
                        </Link>
                        <Link :href="route('B2BForWorkshops')">
                            <li class="block px-4 py-4 font-medium cursor-pointer md:hover:bg-gray-100">
                                <div
                                    class="flex items-center gap-2 text-sm font-bold leading-tight mt-0.5">
                                     Производительным цехам
                                </div>
                            </li>
                        </Link>
                    </ul>
                </template>
            </ModalSelect>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
